import AppWrappedTextbox from '../../AppWrappedTextbox';
import NPIVerification from './NPIVerification';
import { fetchNpiData, fetchNpiDataByTN } from '../_api';
import { MESSAGE_BANNER_TYPES } from '_types';

const NPINumberField = ({
	id,
	idVerification,
	formik,
	trackingNumber,
	lastName = '',
	firstName = '',
}) => {
	return (
		<>
			<AppWrappedTextbox
				name={id}
				isRequired
				label='NPI'
				formik={formik}
				helperText={
					<>
						NPI is required based on the job category you selected.
						If you do not know the number, please look it up on the{' '}
						<a
							href='https://npiregistry.cms.hhs.gov/search'
							target='_blank'
							rel='noopener noreferrer'
						>
							NPI Registry
						</a>
						.
					</>
				}
			/>
			{!formik.errors[id] && formik.values[id] && (
				<NPIVerification
					id={idVerification}
					value={formik.values[id]}
					trackingNumber={trackingNumber}
					lastName={lastName}
					firstName={firstName}
					formik={formik}
				/>
			)}
		</>
	);
};

export const ValidateYupNPI = async (value, context) => {
	if (value) {
		//check if it is a number
		if (isNaN(value) || isNaN(parseFloat(value))) {
			return context.createError({
				message: 'NPI must contain only numbers.',
			});
		}

		//check against NPI Registry
		if (value.length === 10) {
			// read static values expected in context to assist validation
			const { messages } = context.parent['TRACKING_NUMBER']
				? await fetchNpiDataByTN(
						value,
						context.parent['TRACKING_NUMBER'],
					)
				: await fetchNpiData(
						value,
						context.parent['LAST_NAME'],
						context.parent['FIRST_NAME'],
					);
			if (
				messages?.length > 0 &&
				messages[0]?.Key === MESSAGE_BANNER_TYPES.ERROR
			) {
				return context.createError({
					message: `${messages[0].Value} Please try again.`,
				});
			}
			if (
				messages?.length > 0 &&
				messages[0]?.Key === MESSAGE_BANNER_TYPES.WARNING
			) {
				return context.createError({
					message: `${messages[0].Value} Please search another number.`,
				});
			}

			return true;
		} else {
			return context.createError({
				message: 'An NPI number must be 10 digits.',
			});
		}
	} else {
		return context.createError({
			message: 'NPI is required.',
		});
	}
};

export default NPINumberField;
